import React, { Component } from 'react';

export class CardActionRecommendationView extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const {
      trade,
    } = this.props;
    const client = trade.client || {};

    const isManualRedeemStatus = client.redeemStatus === 'redeem' || client.redeemStatus === 'hold';
    const redeemRecommendation = trade.redeemRecommendation;


    return (
      <ul>
        {redeemRecommendation !== 'hold' && (
          <li className="warning">
            This is a high risk user.  The card should be redeem into our account if valid and the
            appropriate steps have been followed.
            {isManualRedeemStatus && (
              <span> [* Set manually]</span>
            )}
          </li>
        )}

        {redeemRecommendation === 'hold' && (
          <li className="suggestion">
            This is a trusted user. You should consider not redeeming the card.
            {isManualRedeemStatus && (
              <span> [* Set manually]</span>
            )}
          </li>
        )}
      </ul>

    );
  }

}

export default CardActionRecommendationView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/CardActionRecommendation/CardActionRecommendation.view.js